import React from "react";

import {
  IgBadge,
  IgChip,
  IgCustomTheme,
  IgDivider,
} from "@intelligems/ig-theme";
import { Box, List, useTheme } from "@mui/material";
import { useConfiguration } from "@src/api/configurations/use-configuration";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { useIsAdmin } from "@src/api/user-auths/is-admin";
import {
  checkAnyScope,
  checkBooleanScope,
} from "@src/components/LimitAccess/check-scopes";
import { IgListItemLink } from "@src/components/Navigation/BaseSideNav/IgListItemLink";
import { SectionHeader } from "@src/components/Navigation/BaseSideNav/SectionHeader";
import { StandardRoutes } from "@src/components/Utils/routes";

interface TopNavSectionProps {
  drawerOpen: boolean;
}
export const TopNavSection = ({ drawerOpen }: TopNavSectionProps) => {
  const theme = useTheme<IgCustomTheme>();
  const organization = useGetOrg();
  const isAdmin = useIsAdmin();
  const viewNewAnalytics = useConfiguration("view_analytics");
  const viewSiteWideAnalytics = useConfiguration("view_sitewide_analytics");

  return (
    <List sx={{ px: drawerOpen ? 2 : 4 }}>
      <IgListItemLink
        drawerOpen={drawerOpen}
        Route={StandardRoutes().home}
        hasAccess={true}
        exact={true}
      />

      {(isAdmin || viewSiteWideAnalytics?.value) && (
        <IgListItemLink
          Route={StandardRoutes().sitewideAnalytics}
          drawerOpen={drawerOpen}
          hasAccess={
            checkBooleanScope(
              "view_sitewide_analytics",
              organization.data.org.configurations
            ) ||
            isAdmin ||
            false
          }
          exact={true}
        />
      )}

      <SectionHeader title="Profit growth platform" drawerOpen={drawerOpen} />

      <IgListItemLink
        drawerOpen={drawerOpen}
        Route={StandardRoutes().experiments}
        hasAccess={true}
        exact={true}
      />

      <IgListItemLink
        drawerOpen={drawerOpen}
        Route={StandardRoutes().experiences}
        hasAccess={checkAnyScope([
          isAdmin || false,
          checkBooleanScope(
            "personalizations",
            organization.data.org.configurations
          ),
        ])}
        exact={true}
      />

      {drawerOpen ? (
        <Box sx={{ display: "flex" }}>
          <IgDivider
            orientation="vertical"
            sx={{
              height: "64px",
              marginLeft: 6,
              marginTop: "4px",
            }}
          />
          <Box sx={{ flex: 1 }}>
            {StandardRoutes().experiences.subRoutes?.map((route) => (
              <IgListItemLink
                key={route.path}
                drawerOpen={drawerOpen}
                Route={route}
                isSubRoute={true}
                hasAccess={checkAnyScope([
                  isAdmin || false,
                  checkBooleanScope(
                    "personalizations",
                    organization.data.org.configurations
                  ),
                ])}
                chip={
                  route.sidebarName === "Offers" ? (
                    <IgBadge
                      badgeContent="New!"
                      sx={{
                        "& .MuiBadge-badge": {
                          position: "relative",
                          transform: "none",
                          fontSize: "11px",
                          height: "18px",
                          minWidth: "33px",
                          padding: "2px 4px 2px 4px",
                          borderRadius: 1,
                          backgroundColor: theme.igBackgroundColors.accent,
                          color: theme.palette.text.accent,
                          marginLeft: 1,
                        },
                      }}
                    />
                  ) : undefined
                }
              />
            ))}
          </Box>
        </Box>
      ) : (
        StandardRoutes().experiences.subRoutes?.map((route) => (
          <IgListItemLink
            key={route.path}
            drawerOpen={drawerOpen}
            Route={route}
            isSubRoute={true}
            hasAccess={checkAnyScope([
              isAdmin || false,
              checkBooleanScope(
                "personalizations",
                organization.data.org.configurations
              ),
            ])}
          />
        ))
      )}
      {/*{isAdmin && (*/}
      {/*  <IgListItemLink*/}
      {/*    drawerOpen={drawerOpen}*/}
      {/*    Route={StandardRoutes().sitewideAnalytics}*/}
      {/*    hasAccess={isAdmin}*/}
      {/*    exact={true}*/}
      {/*  />*/}
      {/*)}*/}
    </List>
  );
};
